export enum SourcesUsesCategories {
	Receivables = 'receivables',
	Payables = 'payables',
	CashOnBalanceSheet = 'cashOnBalanceSheet',
	RetainedCashAndHoldbacks = 'retainedCashAndHoldbacks',
}

export enum SourcesUsesTableKeys {
	Name = 'name',
	InputAmount = 'inputAmount',
	ConvertedAmount = 'convertedAmount',
	Actions = 'actions',
}

export const SourcesUsesUndistributedRowId = 'custom-undistributed';
